import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, CircleMarker, useMap, useMapEvents } from 'react-leaflet';
import { validCoordinates } from '@/components/LocationMap';

function PointEvents({ location, onChange }) {
  const map = useMap();
  useMapEvents({ click: event => onChange({lat: Number(event.latlng.lat.toFixed(6)), lng: Number(event.latlng.lng.toFixed(6))}) });
  useEffect(() => {
    if (validCoordinates(location)) map.panTo([location.lat, location.lng]);
  }, [map, location]);
  useEffect(() => {
    const observer = new ResizeObserver(() => map.invalidateSize());
    observer.observe(map.getContainer());
    return () => observer.disconnect();
  }, [map]);
  return validCoordinates(location) ? <CircleMarker center={[location.lat,location.lng]} radius={9} pathOptions={{color:'#34492f',fillColor:'#E3B24C',fillOpacity:1}} /> : null;
}

export default function LocationPicker({ location, onChange, lang }) {
  const [open,setOpen] = useState(false);
  const it = lang === 'it';
  const selected = validCoordinates(location);
  return <div className="mt-3">
    <button type="button" aria-expanded={open} onClick={()=>setOpen(!open)} className="text-sm underline text-[#557448]">{open ? (it ? 'Chiudi la mappa' : 'Close map') : (it ? 'Scegli il punto sulla mappa' : 'Choose location on map')}</button>
    {open && <>
      <p className="text-sm my-2">{it ? 'Ingrandisci e clicca o tocca la mappa per posizionare il punto. Per spostarlo, scegli un altro punto. Le coordinate si aggiornano automaticamente; al termine salva la scheda.' : 'Zoom in and click or tap the map to place the marker. Choose another point to move it. Coordinates update automatically; save the profile when finished.'}</p>
      <div className="h-72 rounded-xl overflow-hidden border relative z-0" role="region" aria-label={it ? 'Selezione del punto sulla mappa' : 'Map location picker'}>
        <MapContainer center={selected ? [location.lat,location.lng] : [20,0]} zoom={selected ? 15 : 2} scrollWheelZoom={false} className="h-full w-full">
          <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <PointEvents location={location} onChange={onChange} />
        </MapContainer>
      </div>
    </>}
  </div>;
}
